const DB_NAME = 'HaHu';
const DB_VERSION = 1;
const STORE_NAME = 'adVisits';
const DAYS_TO_KEEP = 30;

let db = null;

const isIndexedDBAvailable = () => {
  try {
    return typeof indexedDB !== 'undefined' && indexedDB !== null;
  } catch {
    return false;
  }
};

const init = async () => {
  if (!isIndexedDBAvailable()) {
    return null;
  }

  return new Promise((resolve) => {
    try {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onerror = () => {
        resolve(null);
      };

      request.onsuccess = (event) => {
        db = event.target.result;
        resolve(db);
      };

      request.onupgradeneeded = (event) => {
        const database = event.target.result;

        if (!database.objectStoreNames.contains(STORE_NAME)) {
          const objectStore = database.createObjectStore(STORE_NAME, { keyPath: 'adId' });
          objectStore.createIndex('visitedAt', 'visitedAt', { unique: false });
        }
      };
    } catch {
      resolve(null);
    }
  });
};

export const saveVisit = async (adId) => {
  if (!db) {
    await init();
  }

  if (!db) {
    return null;
  }

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const objectStore = transaction.objectStore(STORE_NAME);

    const visitData = {
      adId,
      visitedAt: new Date(),
    };

    const request = objectStore.put(visitData);

    request.onsuccess = () => {
      resolve(visitData);
    };

    request.onerror = () => {
      reject(new Error('Failed to save visit'));
    };
  });
};

export const isVisited = async (adId) => {
  if (!db) {
    await init();
  }

  if (!db) {
    return false;
  }

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readonly');
    const objectStore = transaction.objectStore(STORE_NAME);
    const request = objectStore.get(adId);

    request.onsuccess = () => {
      resolve(request.result !== undefined);
    };

    request.onerror = () => {
      reject(new Error('Failed to check visit'));
    };
  });
};

export const cleanupOldVisits = async () => {
  if (!db) {
    await init();
  }

  if (!db) {
    return null;
  }

  return new Promise((resolve, reject) => {
    const transaction = db.transaction([STORE_NAME], 'readwrite');
    const objectStore = transaction.objectStore(STORE_NAME);
    const visitedAtIndex = objectStore.index('visitedAt');

    const cutoffDate = new Date();
    cutoffDate.setDate(cutoffDate.getDate() - DAYS_TO_KEEP);
    const range = IDBKeyRange.upperBound(cutoffDate);

    const request = visitedAtIndex.openCursor(range);
    let deletedCount = 0;

    request.onsuccess = (event) => {
      const cursor = event.target.result;

      if (cursor) {
        cursor.delete();
        deletedCount++;
        cursor.continue();
      } else {
        resolve({ deletedCount, cutoffDate });
      }
    };

    request.onerror = () => {
      reject(new Error('Failed to cleanup old visits'));
    };
  });
};
